import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import $ from 'jquery';

class HostelPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			
		}
	}
	
  render() {
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="fa fa-bank"></i>&nbsp; Hostel</a>
		  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>
		  <div className="collapse navbar-collapse" id="navbarSupportedContent">
			<ul className="navbar-nav mr-auto">
			  <li className="nav-item active">
				<Link to="/hostel/hostellist" className="nav-link" >Hostel List</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/hostel/floors" className="nav-link" >Floor</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/hostel/rooms" className="nav-link" >Room</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/hostel/admission" className="nav-link" >Hostel Applications</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/hostel/hostellers" className="nav-link" >Hostellers</Link>
			  </li>
			</ul>
		  </div>
		</nav>
    )
  }
}

export default HostelPage;


// WEBPACK FOOTER //
// ./src/views/HostelPage/HostelPage.js